import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=8516ac34"
import script from "./SubscriptionList.vue?vue&type=script&lang=js"
export * from "./SubscriptionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports